import { render } from "./ImportHistoryComponent.vue?vue&type=template&id=b15f86bc"
import script from "./ImportHistoryComponent.vue?vue&type=script&lang=js"
export * from "./ImportHistoryComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vincent/Herd/app.prixo.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__